export const environment = {
  appVersion: require('../../package.json').version + '-staging',
  production: false,
  wsUrl: 'wss://staging.creator.talentlitmus.com',
  serverUrl: 'https://staging.adminv2.talentlitmus.com',
  serverV1Url: 'https://staging.talentlitmus.com',
  gameRoot: 'https://webgames.talentlitmus.com/genie-game-staging/',
  kbcRoot: 'https://webgames.talentlitmus.com/genie-kbc-staging/',
  leaderboardUrl: 'https://leaderboard2.talentlitmus.com/genie-staging',
  cacheDbName: 'tl-genie',
  socketUrl: 'https://api.multiplayer.game.staging.talentlitmus.com',
  multiplayerApiUrl: 'https://api.multiplayer.game.staging.talentlitmus.com',
};

export const REFRESH_TIME_IN_MINUTES = 0.1;
